import { useLocation } from "react-router";
import { useGlobalContext } from "../utils/GlobalContext";

export const useGetPathnameMinusLocale = () => {
  const location = useLocation();
  const { locale } = useGlobalContext();

  return location.pathname.replace(`/${locale.toLowerCase()}`, "");
};
